// extracted by mini-css-extract-plugin
module.exports = {"company":"Me-module__company--7jvFc"};